import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const adminApiEndPoint = `${process.env.NEXT_PUBLIC_APP_API_URL}/api/admin`;

/**
 * Thunk to fetch global analytics data for the admin dashboard.
 */
export const getAdminAnalyticsThunk = createAsyncThunk(
    "analytics/getStats",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${adminApiEndPoint}/dashboard-stats`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch analytics" }
            );
        }
    }
);
